import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { EVENT_NAME } from '../../../analytics-event/analytics.constant';
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
 * Import constant file.
 */
import { GAME_RANK, NUMBERS, PRODUCT_TYPE_CONSTANT, SCREEN_NAME } from '../../../constants/app.constants';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  @Input() isTopScore: boolean;
  @Input() columnCard: number;
  @Input() ranking: number;
  @Input() playerObj;
  @Input() gameId: number;

  /**
   * Analyticsdata object.
   */
  public analyticsProfileData: AnalyticsInterface;

  @Output() navigateToProfile = new EventEmitter();

  /**
   * Values from constants.
   */
  public gameRank = GAME_RANK;
  public numbers = NUMBERS;

  constructor() {
    // No Code
  }

  ngOnInit(): void {
    this.analyticsProfileData = {
      'event_name': EVENT_NAME.PROFILE_CLICK,
      'product_type': PRODUCT_TYPE_CONSTANT.NCP_SUB_TYPE,
      'product_type_id': this.gameId,
      'screen_name': SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE,
    };
  }

  navigateToUserProfile(customId: string): void {
    this.navigateToProfile.emit(customId);
  }

}
